import { compose, map, path, prop } from "ramda";

import API from "../../api";
import { Guestbook, Comments, Comment } from "./entities";

export const getGuestbooks = (ids) =>
  API.Talkbox.getGuestbooks({ guestbook_keys: ids }).then(
    compose(map(Guestbook), path(["data", "items"]))
  );

export const getComments = ({guestbookKey, page, pageSize}) =>
  API.Talkbox.getComments({
    guestbook_key: guestbookKey,
    page,
    page_size: pageSize
  })
    .then(prop("data"))
    .then(Comments);

export const createComment = params =>
  API.Talkbox.createComment(params).then(prop('data')).then(Comment);

export const likeComment = ({commentId, guestbookKey}) =>
  API.Talkbox.createCommentVote({
    comment_id: commentId,
    guestbook_key: guestbookKey,
    vote_type: 'like',
  })

export const unlikeComment = ({commentId, guestbookKey}) =>
  API.Talkbox.deleteCommentVote({
    comment_id: commentId,
    guestbook_key: guestbookKey,
    vote_type: 'like',
  })
